export const APP_NAME = 'seller_page_perseus';
export const PAGE_NAME = 'seller_page';
